import axios, { AxiosError, AxiosResponse } from "axios";
import { AppDispatch } from "../app/store";
import { openSnackbar } from "../features/snackbar/globalSnackbarSlice";

export const errorHandler = (error: unknown, dispatch: AppDispatch): void => {

if (isValidationError(error)) {
dispatch(
  openSnackbar({
    title: "Das hat leider nicht geklappt. ",
    message: "Versuchen Sie es erneut oder wenden Sie sich unter Angabe des Fehlercodes " + error.response.headers['x-request-id'] + " an den Helpdesk.",
    severity: "error",
    duration: 20000,
    dateAndTime: " " + error.response.headers['date'],
    requestUrl: " " + error.config.baseURL + error.config.url,
    statusCode: " " + error.response.status,
    xRequestID: " " + error.response.headers['x-request-id']
  })
);
} else if (isInternalError(error)) {
  dispatch(
    openSnackbar({
      title: "Das hat leider nicht geklappt. ",
      message: "Versuchen Sie es erneut oder wenden Sie sich unter Angabe des Fehlercodes " + error.response.headers['x-request-id'] + " an den Helpdesk.",
      severity: "error",
      duration: 20000,
      dateAndTime:  " " + error.response.headers['date'],
      requestUrl: " " + error.config.baseURL + error.config.url,
      statusCode: " " + error.response.status,
      xRequestID: " " + error.response.headers['x-request-id']
    })
  );
} else if (isNetworkError(error)) {
  // dispatch(setStatus(0))
  dispatch(openSnackbar({
    title: "Das hat leider nicht geklappt. ",
    message: "Versuchen Sie es erneut oder wenden Sie sich an den Helpdesk.",
    severity: "error",
    duration: 20000,
    dateAndTime: " " + new Date().toLocaleString(),
    requestUrl: " " + error.config.baseURL + error.config.url,
    statusCode: " Network error ",
    xRequestID: " "
  }))
} else if (isUnexpectedError(error)) {
  dispatch(
    openSnackbar({
      title: "Das hat leider nicht geklappt. ",
      message: !error.response ? "Versuchen Sie es erneut oder wenden Sie sich an den Helpdesk." : "Versuchen Sie es erneut oder wenden Sie sich unter Angabe des Fehlercodes " + error.response?.headers['x-request-id'] + " an den Helpdesk.",
      severity: "error",
      duration: 20000,
      dateAndTime: !error.response ? new Date().toLocaleString() + "" : "  " + error.response?.headers['date'],
      requestUrl: " " + error.config.baseURL + error.config.url,
      statusCode: !error.response ? "Unexpected error" : " " + error.response?.status,
      xRequestID: !error.response ? "" : " " + error.response?.headers['x-request-id']
    })
  );
}
}

interface ValidationResponse extends AxiosResponse {
  status: 400;
  data: {
    type: string;
    title: string;
    traceId: string;
    status: number;
    errors: {name: string[]};
  };
}

interface InternalResponse extends AxiosResponse {
  status: 500;
  data: {
    type: string;
    title: string;
    traceId: string;
    status: number;
    detail: string; 
   };
}



export interface ValidationError extends AxiosError {
  response: ValidationResponse;
}
export interface InternalError extends AxiosError {
  response: InternalResponse;
}

function axiosResponseIsValidationResponse(response: AxiosResponse ): response is ValidationResponse {

 const responseNew = response as ValidationResponse;

  return response.status === 400
      && typeof responseNew.data?.title === 'string'
      && typeof responseNew.data?.errors === 'object';
}

function axiosResponseIsInternalResponse(response: AxiosResponse ): response is InternalResponse {

  const responseNew = response as InternalResponse;
 
   return response.status === 500
       && typeof responseNew.data?.title === 'string'
       && typeof responseNew.data?.detail === 'string'
 }

export function isValidationError(error: unknown): error is ValidationError {
  return Boolean(
      axios.isAxiosError(error)
      && error.response
      && axiosResponseIsValidationResponse(error.response)
  );
}

export function isNetworkError(error: unknown): error is AxiosError {
  return Boolean(
    axios.isAxiosError(error) 
    && error.message === "Network Error"
  )
}

export function isInternalError(error: unknown): error is InternalError {
  return Boolean(
      axios.isAxiosError(error)
      && error.response
      && axiosResponseIsInternalResponse(error.response)
  );
}

export function isUnexpectedError(error: unknown): error is AxiosError {
  return Boolean(
      axios.isAxiosError(error)
  );
}


